import { render } from "./SideM.vue?vue&type=template&id=cfbd87c4&scoped=true"
import script from "./SideM.vue?vue&type=script&lang=js"
export * from "./SideM.vue?vue&type=script&lang=js"

import "./SideM.vue?vue&type=style&index=0&id=cfbd87c4&scoped=true&lang=css"

import exportComponent from "E:\\newwww\\shared_space\\shared_store\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfbd87c4"]])

export default __exports__